import { Spin } from 'antd';

export default () => {
  return <Spin />;
};
